/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The kind of source that can be linked to an environment
 */
export const SourceEnvironmentLinkSourceKind = {
  Http: "http",
  Function: "function",
} as const;
/**
 * The kind of source that can be linked to an environment
 */
export type SourceEnvironmentLinkSourceKind = ClosedEnum<
  typeof SourceEnvironmentLinkSourceKind
>;

/**
 * A link between a source and an environment
 */
export type SourceEnvironmentLink = {
  /**
   * The ID of the environment
   */
  environmentId: string;
  /**
   * The ID of the source environment link
   */
  id: string;
  /**
   * The kind of source that can be linked to an environment
   */
  sourceKind: SourceEnvironmentLinkSourceKind;
  /**
   * The slug of the source
   */
  sourceSlug: string;
};

/** @internal */
export const SourceEnvironmentLinkSourceKind$inboundSchema: z.ZodMiniEnum<
  typeof SourceEnvironmentLinkSourceKind
> = z.enum(SourceEnvironmentLinkSourceKind);

/** @internal */
export const SourceEnvironmentLink$inboundSchema: z.ZodMiniType<
  SourceEnvironmentLink,
  unknown
> = z.pipe(
  z.object({
    environment_id: z.string(),
    id: z.string(),
    source_kind: SourceEnvironmentLinkSourceKind$inboundSchema,
    source_slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "environment_id": "environmentId",
      "source_kind": "sourceKind",
      "source_slug": "sourceSlug",
    });
  }),
);

export function sourceEnvironmentLinkFromJSON(
  jsonString: string,
): SafeParseResult<SourceEnvironmentLink, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SourceEnvironmentLink$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SourceEnvironmentLink' from JSON`,
  );
}
